var headerScrollAttacher = function () {
    var reactWindowList = document.querySelector('.List');
    var gridHeader = document.querySelector('.data-grid-head-container');
    var gridFooter = document.querySelector('.data-grid-footer-container');
    reactWindowList === null || reactWindowList === void 0 ? void 0 : reactWindowList.addEventListener('scroll', function (e) {
        gridHeader === null || gridHeader === void 0 ? void 0 : gridHeader.scroll({ left: reactWindowList.scrollLeft });
        gridFooter === null || gridFooter === void 0 ? void 0 : gridFooter.scroll({ left: reactWindowList.scrollLeft });
    });
};
var reactWindowFixer = function () {
    headerScrollAttacher();
};
export default reactWindowFixer;
